import {createStore} from "vuex";
import axios from 'axios';

export default createStore({
    state: {
        hideConfigButton: false,
        isPinned: true,
        showConfig: false,
        sidebarType: "bg-white",
        isRTL: false,
        mColor: "",
        darkMode: false,
        isNavFixed: true,
        isAbsolute: false,
        showNavs: true,
        showSidenav: true,
        showNavbar: true,
        showFooter: true,
        showMain: true,
        layout: "default", // Start of new code
        // api: import.meta.env.VITE_BASE_API,
        api: "https://sub.apiproxy.co/", // ... (actual base url)
        token: "Mjk2NTkwNzhhYjVlYThkODBlZWIzMDYzYmE0YmI1Y2Q=",
        appKey: "QGohdFLe3w-AWjfdy7jXrZvtIMUrmPwpocQtCsRPZsF-QIuw7AKAw4",
        authKey: "4ia2yg.Gs42I0h7(%!{FjDAt{.R5Z-",

    },

    getters: {
        isAuthenticated: state => !!state.token,
        StateApi: state => state.api,
        StateToken: state => state.token,
        //
        StatePermission: state => state.permission,
        StateAppKey: state => state.appKey,
        StateAuthKey: state => state.authKey,
        StateHashKey: state => state.hashKey,
        StateAuthKeyWeb: state => state.authKeyWeb,
    },

    actions: {
        toggleSidebarColor({commit}, payload) {
            commit("sidebarType", payload);
        },

        // HE
        // eslint-disable-next-line no-unused-vars
        async getHeaders({commit, getters}, params) {
            let res = {}
            await axios.get('http://header.safaricombeats.co.ke/', {})
                .then(async function (response) {

                    res.message = response.data

                })
                .catch(function (error) {

                    console.log(`HE Error: ${error}`)
                })

            return res
        },


        // MT Activate
        // eslint-disable-next-line no-unused-vars
        async mtActivate({commit, getters}, payload) {
            let res = {}
            const parsedPayload = JSON.parse(JSON.stringify(payload));
            const productId = parsedPayload.product_id;
            delete parsedPayload.product_id;

            await axios.post(getters.StateApi + 'wh/v1/mt_activate/' + productId, payload,
                {
                    headers: {
                        'X-Hash-Key': getters.StateHashKey,
                        'X-App-Key': getters.StateAppKey,
                    }
                })
                .then(async function (response) {

                    console.log("mtActivate Res: ",JSON.stringify(response))
                    res.status = response.data.data.code
                    res.message = response.data.data.message
                    res.data = response.data.data.data

                })
                .catch(function (error) {
                    console.log(`mtActivate Error: ${error}`)
                })

            return res
        },

        //end of actions
    },


});
